export interface SupplierProduct {
  id: string;
  supplierKey: string;
  supplierName: string;
  default: string;
  partNo: string;
  currencyCode: string;
  currencySymbol: string;
  stdPrice: number;
  stdCutPrice: number;
  minimumOrderQty: number;
}
